<div class="flex flex-column md:flex-row align-items-stretch gap-3 mb-2" *ngIf="!isViewOnly()">
  <app-metric
    class="w-12 md:w-6"
    title="Σύνολο προγραμματισμένων χειρουργείων"
    subtitle=""
    [value]="scheduledSurgeriesCount"
    icon="pi pi-thumbs-up text-white"
    iconBg="bg-green-500"
    [loading]="isScheduledSurgeriesLoading()"
    [pTooltip]="
      isToolTipVisible() ? 'Ο αριθμός διαφέρει ανάλογα με την κλινική.' : ''
    "
    tooltipPosition="top"
  >
  </app-metric>

  <app-metric
    class="w-12 md:w-6"
    title="Σύνολο μη προγραμματισμένων χειρουργείων"
    subtitle=""
    [value]="unScheduledSurgeriesCount"
    icon="pi pi-thumbs-down text-white"
    iconBg="bg-red-500"
    [loading]="isUnScheduledSurgeriesLoading()"
    [pTooltip]="
      isToolTipVisible() ? 'Ο αριθμός διαφέρει ανάλογα με την κλινική.' : ''
    "
    tooltipPosition="top"
  >
  </app-metric>
</div>

<eo-search-page
  [formConfig]="formConfig"
  [tableConfig]="tableConfig"
  [searchServ]="searchService"
  [page]="getPage()"
  [pagesize]="getPagesize()"
  [totalCount]="getTotalCount()"
  [loading]="isLoading()"
  [viewModeVisible]="false"
  [menuActions]="[]"
  (search)="onSearch($event)"
  [customFormControls]="{
    hospitalID: hospitalID,
    clinicID: clinicID,
    hospitalAvailabilityID: hospitalAvailabilityID
  }"
  (clearEvent)="onClearEvent()"
  [initData]="false"
  [collapsed]="false"
>
  <ng-template
    #hospitalID
    let-formGroup="formGroup"
    let-config="config"
    let-styleClass="styleClass"
  >
    <ng-container [formGroup]="formGroup">
      <app-hospital-dropdown
        [label]="config.label"
        [class]="styleClass"
        [config]="config"
        (change)="onHospitalChange($event)"
        formControlName="hospitalID"
      />
    </ng-container>
  </ng-template>
  <ng-template
    #clinicID
    let-formGroup="formGroup"
    let-config="config"
    let-styleClass="styleClass"
  >
    <ng-container [formGroup]="formGroup">
      <app-clinic-dropdown
        [label]="config.label"
        [class]="styleClass"
        [config]="config"
        formControlName="clinicID"
        [hospitalId]="hospitalId"
        (change)="onClinicChange($event)"
        [showClear]="tokenData?.clinicId == null"
      />
    </ng-container>
  </ng-template>
  <ng-template
    #hospitalAvailabilityID
    let-formGroup="formGroup"
    let-config="config"
    let-styleClass="styleClass"
  >
  <ng-container [formGroup]="formGroup">
    <eo-dropdown
      [label]="config.label"
      [class]="styleClass"
      [config]="config"
      formControlName="hospitalAvailabilityID"
      optionLabel="availabilityTextNoSlots"
      optionValue="id"
      [placeholder]="
        isPrivateHospitalAdmin()
          ? 'Επιλέξτε κλινική για εμφάνιση αποτελεσμάτων'
          : 'Επιλέξτε μήνα'
      "
      [showClear]="true"
      [options]="hospitalAvailabilities ?? []"
      [loading]="isFetchHospitalAvailabilitiesLoading()"
    ></eo-dropdown>
  </ng-container>
  
  </ng-template>
</eo-search-page>

<app-surgery-schedule-form-dialog
  #surgeryScheduleFormDialog
  (success)="onTriggerSearch()"
/>

<app-surgery-cancel-form-dialog
  #surgeryCancelFormDialog
  (success)="onTriggerSearch()"
/>
